import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  termsContainer: ({ spacing }) => css`
    max-width: calc(100% - ${spacing.md});
  `,
})

export default useStyles
